export function header($) {
  jQuery(document).ready(function ($) {
    var $menu = $('#mobileMenu');
    var $search = $('#mobileSearch');
    var $burger = $('.burger-toggle-btn');
    var $searchBtn = $('.search-toggle-btn');
    function closeAll() {
      $menu.removeClass('show');
      $search.removeClass('show');
      $burger.removeClass('is-active');
      $searchBtn.removeClass('is-active');
    }

    // BURGER
    $burger.on('click', function () {
      var open = !$menu.hasClass('show');
      closeAll();
      if (open) {
        $menu.addClass('show');
        $burger.addClass('is-active');
      }
    });

    // SEARCH
    $searchBtn.on('click', function () {
      var open = !$search.hasClass('show');
      closeAll();
      if (open) {
        $search.addClass('show');
        $searchBtn.addClass('is-active');
      }
    });
  });
  function updateMaltaClock() {
    var options = {
      timeZone: 'Europe/Malta',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    };
    var maltaTime = new Intl.DateTimeFormat('en-GB', options).format(new Date());
    var clockElement = document.getElementById('live-clock');
    if (clockElement) {
      clockElement.textContent = maltaTime + ' MT';
    }
  }
  setInterval(updateMaltaClock, 1000);
  updateMaltaClock();
}